module.exports = JSON.parse('{"Tracked series":"{{trackedSeries}} Gevolgde serie"}')